<template>
  <div>
    <el-row :gutter="12">
      <el-col :span="4">
        <el-card shadow="hover" style="position: relative">
          <div>
            <div class="card-title-css">包体大小</div>
            <div class="card-value-css">
              {{ humanSize(topData.package_size, 2) }}
            </div>
            <i class="iconfont icon-folder card-i-css"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style="position: relative">
          <div style="cursor: pointer" @click="handleChooseCard('scenelist')">
            <div class="card-title-css">场景数</div>
            <div class="card-value-css">{{ topData.scene_number }}</div>
            <i class="iconfont icon-picture card-i-css"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style="position: relative">
          <div style="cursor: pointer" @click="handleChooseCard('boundlelist')">
            <div class="card-title-css">AB包数</div>
            <div class="card-value-css">{{ topData.bundle_number }}</div>
            <i class="iconfont icon-folder card-i-css"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style="position: relative">
          <div style="cursor: pointer" @click="handleChooseCard('assetslist')">
            <div class="card-title-css">资源总数</div>
            <div class="card-value-css">{{ topData.asset_number }}</div>
            <i class="iconfont icon-rizhi card-i-css"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style="position: relative">
          <div
            style="cursor: pointer"
            @click="handleChooseCard('boundlelist_circlebundle')"
          >
            <div class="card-title-css">AB包循环引用数</div>
            <div class="card-value-css">{{ topData.circle_number }}</div>
            <i class="iconfont icon-shuaxin card-i-css"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style="position: relative">
          <div
            style="cursor: pointer"
            @click="handleChooseCard('boundlelist_toobig')"
          >
            <div class="card-title-css">AB包过大</div>
            <div class="card-value-css">{{ topData.too_big_bundle }}</div>
            <i class="iconfont icon-folder-opened card-i-css"></i>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="12" class="main-data">
      <el-col :span="12" style="height: 100%">
        <el-card
          shadow="hover"
          class="chart-wrapper"
          style="position: relative; height: 100%"
        >
          <div class="assetChart" id="assetChart"></div>
          <el-switch
            @change="handleChartTypeChange"
            style="position: absolute; z-index: 17; top: 20px; left: 20px"
            v-model="chartType"
            active-value="size"
            active-text="按大小"
            inactive-value="value"
            inactive-text="按数量"
          >
          </el-switch>
        </el-card>
      </el-col>
      <el-col :span="12" style="height: 100%">
        <div class="search-bar">
          <el-input
            size="large"
            style="width: 100%"
            placeholder="可以输入ab包名，资源名，场景名进行查询"
            @keyup.enter="handleSearchData"
            v-model="searchText"
          >
            <template #append>
              <el-button size="large" @click="handleSearchData"
                ><i class="iconfont icon-sousuo"></i
                ><span>查询一下</span></el-button
              >
            </template>
          </el-input>
        </div>
        <div v-loading="loading" class="table-warpper">
          <el-table size="small" :data="tableData" height="100%" border>
            <el-table-column width="58">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="文件名"> </el-table-column>
            <el-table-column prop="type" width="120" label="类型">
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="count"
              :current-page="cursor"
              :total="total"
              @current-change="pagechange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import {
  defineProps,
  onMounted,
  onBeforeUnmount,
  reactive,
  defineEmits,
  ref,
} from "vue";
import * as echarts from "echarts";
import { humanSize, humanSizePackage } from "@/Utils/UtilTools";
import {
  apiPackageParseAssetsuffix,
  apiPackageParseOverview,
  apiPackageParseFulltext,
} from "@/Api/AppApi";

const props = defineProps(["param"]);
const emit = defineEmits(["selectCard", "selectRow"]);

onMounted(() => {
  loadData();
  loadChartData();
});

onBeforeUnmount(() => {
  if (assetChart) {
    assetChart.dispose();
    assetChart = null;
  }
});

const topData = reactive({
  package_size: "--",
  scene_number: "--",
  bundle_number: "--",
  asset_number: "--",
  circle_number: "--",
  too_big_bundle: "--",
});
async function loadData() {
  const params = { version_id: props.param.versionid };
  const res = await apiPackageParseOverview(params);
  if (res.code === 0) {
    for (const key in res.data) {
      topData[key] = res.data[key];
    }
  }
}

let chartData = null;
async function loadChartData() {
  const params = { version_id: props.param.versionid };
  const res = await apiPackageParseAssetsuffix(params);
  if (res.code === 0) {
    chartData = res.data;
    drawChartData();
  }
}

let assetChart = null;
const chartOption = {
  title: {
    text: "Assets资源分布",
    left: "center",
  },
  tooltip: {
    show: true,
    formatter: tooltipformater,
  },
  series: [
    {
      type: "treemap",
      visibleMin: 300,
      label: {
        show: true,
        formatter: "{b}",
      },
      breadcrumb: {
        show: false,
      },
      itemStyle: {
        borderColor: "#fff",
      },
      tooltip: {
        show: true,
        formatter: tooltipformater,
      },
      data: [{}],
    },
  ],
};
function tooltipformater(params) {
  let res = "";
  if (chartType.value === "size") {
    res +=
      params.marker +
      params.data.name +
      " : " +
      humanSizePackage(params.data.value) +
      "<br/>";
  } else {
    res +=
      params.marker + params.data.name + " : " + params.data.value + "<br/>";
  }

  return res;
}
function drawChartData() {
  let data = [];
  for (const item of chartData) {
    data.push({
      name: item.name,
      value: item[chartType.value],
    });
  }
  if (assetChart == null) {
    assetChart = echarts.init(document.getElementById("assetChart"));
  }
  const option = JSON.parse(JSON.stringify(chartOption));
  option.series[0].data = data;
  assetChart.setOption(option);
}

function handleChooseCard(name) {
  emit("selectCard", name);
}

const typeToView = {
  scene: "scenedetail",
  asset: "assetsdetail",
  bundle: "boundledetail",
};
function handleRowClick(row) {
  const data = {
    viewType: typeToView[row.type],
    name: row.name,
    type: row.type,
  };
  emit("selectRow", data);
}

const chartType = ref("size");
function handleChartTypeChange() {
  drawChartData();
}

const searchText = ref("");
const loading = ref(false);
const tableData = ref([]);
const cursor = ref(1);
const count = ref(30);
const total = ref(0);
async function handleSearchData() {
  const params = {
    keyword: searchText.value,
    version_id: props.param.versionid,
    cursor: cursor.value,
    count: count.value,
  };
  loading.value = true;
  const res = await apiPackageParseFulltext(params);
  loading.value = false;
  if (res.code === 0) {
    total.value = res.data.total;
    tableData.value = res.data.list;
  }
}

function pagechange(pagenum) {
  cursor.value = pagenum;
  handleSearchData();
}
</script>

<style lang="scss" scoped>
.card-title-css {
  font-size: 14px;
}

.card-value-css {
  font-size: 30px;
  color: #1a7dd7;
  margin-top: 5px;
}

.card-i-css {
  position: absolute;
  font-size: 60px;
  left: 147px;
  top: 21px;
  color: #e2e2e2;
}

.main-data {
  margin-top: 12px;
  height: calc(100vh - 283px);
}

.chart-wrapper {
  & :deep() .el-card__body {
    height: 100%;
  }
}

.assetChart {
  height: 100%;
  width: 100%;
  background: #ffffff;
  padding: 30px 20px 20px;
  margin-top: 10px;
}

.search-bar {
  width: 100%;
  margin-bottom: 12px;
}

.table-warpper {
  width: 100%;
  height: calc(100% - 52px);
  padding: 0 0 46px 0;
}

.pagination-wrapper {
  display: flex;
  background-color: #ffffff;
  justify-content: center;
  padding: 5px 0;
}
</style>
